export default __webpack_public_path__ + "static/media/slot4.b1fd86a9.png";